module.exports = __webpack_public_path__ + "img/tag_missing.f11afbb8.svg";